import React from 'react';
import styled from '@emotion/styled';

const Root = styled.span<{ $size: number; $bg?: string; $bordered: boolean }>`
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  border-radius: 50%;
  background: ${({ $bg }) => $bg ?? 'var(--accent)'};
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: ${({ $size }) => `${Math.max(10, Math.round($size * 0.42))}px`};
  overflow: hidden;
  flex-shrink: 0;
  border: ${({ $bordered }) => ($bordered ? '2px solid var(--bg-primary)' : 'none')};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

type Props = {
  name: string;
  url?: string | null;
  color?: string | null;
  size?: number;
  bordered?: boolean;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const Avatar: React.FC<Props> = ({
  name,
  url,
  color,
  size = 28,
  bordered = false,
  title,
  className,
  style,
}) => (
  <Root
    $size={size}
    $bg={color ?? undefined}
    $bordered={bordered}
    title={title ?? name}
    className={className}
    style={style}
  >
    {url ? <img src={url} alt={name} /> : name.slice(0, 1).toUpperCase()}
  </Root>
);
